import { createRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { Route as RootRoute } from './__root';

const ZakaznikForm = lazy(() =>
  import('@/modules/zakaznici/ZakaznikForm').then((m) => ({ default: m.ZakaznikForm })),
);

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/zakaznici/novy',
  component: () => (
    <Suspense fallback={null}>
      <ZakaznikForm />
    </Suspense>
  ),
});
